export type Box = { width: number; height: number }
export type Viewport = { left: number; top: number; width: number; height: number }

const OFFSET = 12
const PADDING = 4

const clamp = (v: number, min: number, max: number) =>
  Math.max(min, Math.min(v, Math.max(min, max)))

/**
 * Позиция всплывашки у точки так, чтобы она целиком оставалась внутри видимой
 * части графика: у правого и нижнего края она переворачивается на другую
 * сторону от курсора, а если не помещается и так — прижимается к краю.
 */
export const placeTooltip = (
  anchorX: number,
  anchorY: number,
  box: Box,
  vp: Viewport
): { left: number; top: number } => {
  let left = anchorX + OFFSET
  if (left + box.width > vp.left + vp.width - PADDING) left = anchorX - OFFSET - box.width
  let top = anchorY + OFFSET
  if (top + box.height > vp.top + vp.height - PADDING) top = anchorY - OFFSET - box.height
  return {
    left: clamp(left, vp.left + PADDING, vp.left + vp.width - box.width - PADDING),
    top: clamp(top, vp.top + PADDING, vp.top + vp.height - box.height - PADDING),
  }
}
